import { render, staticRenderFns } from "./labelTemplateConf.vue?vue&type=template&id=2aa56202&scoped=true"
import script from "./labelTemplateConf.vue?vue&type=script&lang=js"
export * from "./labelTemplateConf.vue?vue&type=script&lang=js"
import style0 from "./labelTemplateConf.vue?vue&type=style&index=0&id=2aa56202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa56202",
  null
  
)

export default component.exports